import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IActiceServiceEventSchema, IServiceEventSchema } from '../../actions/types/services/GetAllServiceEventSchemaTypes';

/**
 * Initial Serivce Event state in store
 */
const initialState: IServiceEventSchema = {
  isLoading: false,
  serviceEventErrorMessage: '',
  activeServiceEventSchema: {
    type: '',
    name: '',
    namespace: '',
    schema: {}
  }
};

const fetchServiceEventSchemaSlice = createSlice({
  name: 'fetchServiceEvent',
  initialState,
  reducers: {
    fetchServiceEventSchemaStarted: (state) => {
      state.isLoading = true;
    },

    fetchServiceEventSchemaSuccess: (state, action: PayloadAction<IActiceServiceEventSchema>) => {
      state.isLoading = false;
      state.activeServiceEventSchema = action.payload;
      state.serviceEventErrorMessage = '';
    },

    fetchServiceEventSchemaFail: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.activeServiceEventSchema = initialState.activeServiceEventSchema;
      state.serviceEventErrorMessage = action.payload;
    },

    clearServiceEventSchemaDetails: (state) => {
      state.isLoading = false;
      state.activeServiceEventSchema = initialState.activeServiceEventSchema;
      state.serviceEventErrorMessage = '';
    }
  }
});
export const {
  fetchServiceEventSchemaStarted,
  fetchServiceEventSchemaSuccess,
  fetchServiceEventSchemaFail,
  clearServiceEventSchemaDetails
} = fetchServiceEventSchemaSlice.actions;
export default fetchServiceEventSchemaSlice.reducer;
